import React from 'react';

import * as styles from './index.module.scss';

import downloadSvg from './../../images/svgs/icons/download.svg';

const Download = ({ title, files, halfWidth = true, showDescriptions = false }) => {
    return(
        files &&
        <div
            className={`${halfWidth ? styles.download : styles.fullWidth}`}
        >
            { title &&
                <h3>{ title }</h3>
            }
            <ul
                className={styles.list}
            >
                { files && files.map((file, index) => {
                    
                    return(
                        <li
                            className={styles.listItem}
                            key={`file-download-${file.title}-${index}`}
                        >
                            <a
                                className={styles.link}
                                href={file.url}
                                target="_blank"
                                title={file.title}
                            >
                                <img
                                    alt="Download Icon"
                                    className={styles.icon}
                                    src={downloadSvg} 
                                />
                                {file?.title}
                            </a>
                            {
                                showDescriptions &&
                                <span 
                                    className={styles.description}
                                >
                                    {file?.description}
                                </span>
                            }
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default Download;